import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0f01435c&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f01435c')) {
      api.createRecord('0f01435c', component.options)
    } else {
      api.reload('0f01435c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0f01435c&", function () {
      api.rerender('0f01435c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InterchangeEventDetail/index.vue"
export default component.exports